import React from 'react'
import { Link } from 'react-router-dom'

const Job = (props) => {
  return (
    <div className='col-xl-3 col-md-5 positions'>
      <Link
        to={`/careers/${props.role._id}`}
        target='_blank'
        className='rolebtn'
      >
        <h4>
          <b>{props.role.positionTitle}</b>
        </h4>
        <p>{props.role.location}</p>
      </Link>
    </div>
  )
}

export default Job
